import * as React from 'react'
import { css } from '@emotion/react'
import { styled } from '@mui/material/styles'
import Image from 'next/image'
import Link from 'next/link'

import { SxProps } from '@mui/material'
import Stack from '@mui/material/Stack'

import Chip from 'components/atomic/atoms/chip'

import Routes from 'utils/routes'

const LogoImage = styled('div')<{ clickable?: boolean }>`
    ${({ clickable }) => {
        if (clickable) {
            return css`
                &:hover {
                    cursor: 'pointer';
                    filter: brightness(0) saturate(100%) invert(94%) sepia(55%) saturate(665%) hue-rotate(10deg)
                        brightness(98%) contrast(86%);
                }
            `
        }
    }}
`

interface LogoProps {
    clickable?: boolean
    link?: string
    label?: boolean
    sx?: SxProps
}

const Logo = (props: LogoProps) => {
    const { clickable = true, link = Routes.Home, label = true } = props

    return (
        <Stack direction="row" alignItems="center" gap={1} sx={props.sx}>
            {clickable ? (
                <Link href={link}>
                    <a>
                        <LogoImage clickable>
                            <Image src={'/assets/logo-extended-white.svg'} alt="Devv logo" height={34} width={96} />
                        </LogoImage>
                    </a>
                </Link>
            ) : (
                <LogoImage clickable={false}>
                    <Image src={'/assets/logo-extended-white.svg'} alt="Devv logo" height={34} width={96} />
                </LogoImage>
            )}

            {label && <Chip sx={{ marginTop: 0.9 }} label="alpha" size="small" />}
        </Stack>
    )
}

export default Logo
